import { Box } from "@chakra-ui/react";
import { getCdnImageSrc, NextLink, useResponsive, VStack } from "goi_common";

export default function SeaBurialList({
  regionSeaBurial,
  eventPath,
}: {
  regionSeaBurial: Array<any>;
  eventPath: "sea_burial" | "sea_burial_region";
}) {
  const { isBiggerThanMd } = useResponsive();

  return (
    <VStack padding={isBiggerThanMd ? "12px 0" : "12px 24px"} gap="12px">
      {regionSeaBurial.map((res, i) => {
        const background = `url(${getCdnImageSrc(`platform/sea-burial/${res.id}.png`)})`;
        return (
          <NextLink
            key={res.companyname + i}
            href={`/facilities/sea-burial/${res.id}/`}
            event={{
              newGtm: { path: eventPath, trigger_and_target: "card-uv_facility" },
            }}
          >
            <VStack
              height="180px"
              background={`${background}`}
              backgroundPosition="center"
              backgroundSize="cover"
              justifyContent="flex-end"
              className="white"
              position="relative"
            >
              <VStack padding="12px 24px" gap="4px" zIndex={3}>
                <Box className="subtitle_16_sb" as="h3">
                  {res.companyname}
                </Box>
                <Box
                  className="caption_12_r"
                  border="1px solid white"
                  borderRadius="30px"
                  padding="4px 10px"
                  width="fit-content"
                  as="p"
                >
                  {res.district}
                </Box>
              </VStack>
              <Box
                width="100%"
                height="90px"
                position="absolute"
                background="linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)"
                zIndex={2}
              />
            </VStack>
          </NextLink>
        );
      })}
    </VStack>
  );
}
